import { CarouselModel } from '@_types/organisms';
import RequireCss from '@helpers/RequireCss';
import RequireJs from '@helpers/RequireJs';
import Quote from '@organisms/quote/Quote';
import Icon from '@atoms/icons/Icon';
import Video from '@organisms/video/Video';
import TrackRecordItem from '@organisms/track-records/TrackRecordItem';
import ContentTile from '@organisms/content-tiles/ContentTile';
import PropertyListingItem from '@organisms/property-listings/PropertyListingItem';
import InsightItem from '@organisms/insights/InsightItem';
import PropertyCategory from '@molecules/propertyCategory/PropertyCategory';
import PodcastItem from '@organisms/podcasts/PodcastItem';
import CategoryImage from '@molecules/categoryImages/CategoryImage';

const Carousel = (model: CarouselModel) => {
  const {
    items,
    hasNavigation,
    hasPagination,
    autoplayTimeout,
    hasLooping,
    subHeader,
    navBarPosition,
    hasPaginationClickable,
    itemType,
    spaceBetween,
    disableAutoHeight,
    excludeJs,
    cssPath,
    edgeSlidesClickabe,
  } = model;

  const overlayCarousel = itemType === 'categoryImage';

  return (
    <div
      className="kf-o-carousel"
      data-autoplay-timeout={autoplayTimeout || undefined}
      data-disable-auto-height={disableAutoHeight}
      data-edge-slides-clickable={edgeSlidesClickabe}
      data-has-looping={hasLooping}
      data-has-navigation={hasNavigation}
      data-has-pagination-clickable={hasPaginationClickable}
      data-item-type={itemType}
      data-space-between={spaceBetween}
    >
      <div className="swiper">
        {navBarPosition === 'top' && <NavigationBar hasNavigation={hasNavigation} hasPagination={hasPagination} />}

        {overlayCarousel && (
          <div className="kf-o-carousel__navigation-button-prev" role="button" tabIndex={0} title="carousel-prev-button">
            <Icon iconPath="#kf-arrow-backward" viewBoxHeight={20} viewBoxWidth={20} />
          </div>
        )}

        <div className="swiper-wrapper">
          {items &&
            items.map((item, key, array) => {
              const { quote, video, trackRecord, contentTile, propertyListing, insight, propertyCategory, podcast, categoryImage } = item;
              const tabIndex = key === 0 ? 0 : -1;

              return (
                <div
                  key={key}
                  className={`swiper-slide ${key === array.length - 1 ? 'swiper-slide-last' : ''} ${key === 0 ? 'swiper-slide-first' : ''}`}
                >
                  {quote && <Quote {...quote} />}
                  {video && <Video {...video} carouselSubHeader={subHeader} tabIndex={tabIndex} />}
                  {trackRecord && <TrackRecordItem {...trackRecord} />}
                  {contentTile && <ContentTile {...contentTile} />}
                  {propertyListing && <PropertyListingItem {...propertyListing} />}
                  {insight && <InsightItem {...insight} />}
                  {podcast && <PodcastItem {...podcast} />}
                  {propertyCategory && <PropertyCategory {...propertyCategory} />}
                  {categoryImage && <CategoryImage {...categoryImage} />}
                </div>
              );
            })}
        </div>

        {(!navBarPosition || navBarPosition === 'bottom') && (
          <NavigationBar hasNavigation={hasNavigation && !overlayCarousel} hasPagination={hasPagination} />
        )}

        {overlayCarousel && (
          <div className="kf-o-carousel__navigation-button-next" role="button" tabIndex={0} title="carousel-next-button">
            <Icon iconPath="#kf-arrow-forward" viewBoxHeight={20} viewBoxWidth={20} />
          </div>
        )}
      </div>

      <RequireCss path={'vendors/swiper@7.3.3/swiper.min'} />
      <RequireCss path={cssPath ?? 'b-carousel'} />
      {!excludeJs && <RequireJs defer path={'carousel'} />}
    </div>
  );
};

export default Carousel;

function NavigationBar(model: { hasNavigation?: boolean; hasPagination?: boolean }) {
  const { hasNavigation, hasPagination } = model;

  return (
    <div className="kf-o-carousel__navigation-container">
      {hasPagination && (
        <>
          <div className="kf-o-carousel__pagination" />
          <div className="kf-o-carousel__pagination-mobile" />
        </>
      )}
      {hasNavigation && (
        <div className="kf-o-carousel__navigation-button">
          <div className="kf-o-carousel__navigation-button-prev" role="button" tabIndex={0} title="carousel-prev-button">
            <Icon iconPath="#kf-arrow-backward" viewBoxHeight={20} viewBoxWidth={20} />
          </div>
          <div className="kf-o-carousel__navigation-button-next" role="button" tabIndex={0} title="carousel-next-button">
            <Icon iconPath="#kf-arrow-forward" viewBoxHeight={20} viewBoxWidth={20} />
          </div>
        </div>
      )}
    </div>
  );
}
